import { decode, PRICE_FACET_ID } from "../codec/urlCodec";

export const PRICE_STEP = 5;

export const isFacetPriceRange = (facet) => facet.id === PRICE_FACET_ID;

const getPrice = (facetValue) => Number(facetValue.id);

const getLowerStep = (prices, step = PRICE_STEP) =>
  Math.floor(Math.min(...prices) / step) * step;

const getHigherStep = (prices, step = PRICE_STEP) =>
  Math.ceil(Math.max(...prices) / step) * step;

export const getBoundsFromApiResponse = (facets = []) => {
  const priceFacet = facets.find(isFacetPriceRange);
  const prices = (priceFacet?.facetValues || []).map(getPrice);

  return prices.length > 0
    ? { min: getLowerStep(prices), max: getHigherStep(prices) }
    : { min: null, max: null };
};

/**
 * The API reports the price range of the products it returned, which is only
 * the whole range when nothing is filtering them. Bounds already recorded in
 * the URL therefore win, so the slider can still be widened back out.
 */
export const computePriceBounds = ({ facets = [], query = {} } = {}) => ({
  ...(decode(query).bounds || getBoundsFromApiResponse(facets)),
  step: PRICE_STEP,
});

export const isPriceNarrowed = (price, bounds) =>
  Boolean(price) &&
  (!Number.isFinite(bounds?.min) ||
    !Number.isFinite(bounds?.max) ||
    price.min > bounds.min ||
    price.max < bounds.max);
